module.exports = require('./lib/axios');


//////////////////
// WEBPACK FOOTER
// /Volumes/MainDrive/Sites/Velindre/web/app/themes/velindre/node_modules/axios/index.js
// module id = 24
// module chunks = 0